import BaseUpdateRequest from '@/models/Shared/BaseUpdateRequest';

export default class UpdateUniformRequest extends BaseUpdateRequest {
    name = '';
    description = '';
}